import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '../views/LoginPage.vue';
import MainPage from '../views/MainPage.vue';
import { doNotShowErrorScreen, loginedUserData, SessionTime } from '@/utils/GlobalUtility';
import DeployPage from '@/views/DeployPage.vue';  // 개발용
import CssTestPage from '@/views/CssTestPage.vue';
import CssTestPage1 from '@/views/CssTestPage1.vue';
import CssTestPage2 from '@/views/CssTestPage2.vue';
import CssTestPage3 from '@/views/CssTestPage3.vue';
import { Company_Name, Get_All_Settings_FromServer, Get_Setting } from '@/utils/Setting';
import { ref } from 'vue';
import RouteRecoderPage from '@/views/RouteRecoderPage.vue';
import DummyData from '@/views/DummyData.vue';

export const isLoginUse = ref(true);

export const setupRouter = async () => {
  await Get_All_Settings_FromServer();
  isLoginUse.value = Get_Setting('use_qls_users');

  const routes = [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
    },
  
    ...(Company_Name.value === 'Qubicom_Dev'
      ? [{
          path: '/route',
          name: 'RouteRecoderPage',
          component: RouteRecoderPage,
      }]
      : []
    ),

    {
      path: '/dummy',
      name: 'DummyData',
      component: DummyData,
    },
    
    ...(process.env.NODE_ENV === 'development'
      ? [{
          path: '/qubicom',
          name: 'DeployPage',
          component: DeployPage,
        },
        {
          path: '/test',
          name: 'CssTestPage',
          component: CssTestPage,
        },
        {
          path: '/test1',
          name: 'CssTestPage1',
          component: CssTestPage1,
        },
        {
          path: '/test2',
          name: 'CssTestPage2',
          component: CssTestPage2,
        },
        {
          path: '/test3',
          name: 'CssTestPage3',
          component: CssTestPage3,
        },]
      : []
    ),
  ];

  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  router.beforeEach((to, from, next) => {
    const session = JSON.parse(localStorage.getItem('session'));
    const currentTime = new Date().getTime();
    doNotShowErrorScreen.value = false;
    
    if (session && session.isLoggedIn) {
      if (currentTime > session.expiry) {
        localStorage.removeItem('session');
        if (Company_Name.value === 'Qubicom_Dev') alert('Your session has expired. Please log in again.');
        next({ name: 'LoginPage' });
      } else {
        if (!to.name) {
          next({ name: from.name || 'MainPage' });
        } else if (loginedUserData() === "Guest") {
          next({ name: 'LoginPage' });
        } else {
          session.expiry = currentTime + SessionTime;
          localStorage.setItem('session', JSON.stringify(session));
          next();
        }
      }
    } else {
      if (to.name !== 'LoginPage' && to.meta.requiresAuth) {
        next({ name: 'LoginPage' });
      } else {
        if (!to.name) {
          next({ name: from.name || 'MainPage' });
        }
        next();
      }
    }
  });

  return router;
};